var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Drawer",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        drawer: _vm.drawer,
        customTitle: false,
        title: _vm.editData.id ? "修改" : "新增",
        size: 1200,
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "div",
        { staticClass: "view" },
        [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "form",
                  attrs: { model: _vm.supplyData, rules: _vm.rules },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4.8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "code", label: "代码" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: { placeholder: "请输入代码" },
                                model: {
                                  value: _vm.supplyData.code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supplyData, "code", $$v)
                                  },
                                  expression: "supplyData.code",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4.8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "wbName", label: "简称" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: { placeholder: "请输入简称" },
                                model: {
                                  value: _vm.supplyData.wbName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supplyData, "wbName", $$v)
                                  },
                                  expression: "supplyData.wbName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 9.6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "name", label: "供应商名称" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "420px" },
                                attrs: { placeholder: "请输入供应商名称" },
                                model: {
                                  value: _vm.supplyData.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supplyData, "name", $$v)
                                  },
                                  expression: "supplyData.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4.8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "isActived", label: "状态" } },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-color": " rgb(18,88,188)",
                                  "inactive-color": "#f1f1f1",
                                },
                                model: {
                                  value: _vm.supplyData.isActived,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supplyData, "isActived", $$v)
                                  },
                                  expression: "supplyData.isActived",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4.8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "supplierScope",
                                label: "业务范畴",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "420px" },
                                  attrs: {
                                    multiple: "",
                                    placeholder: "请选择业务范畴",
                                  },
                                  model: {
                                    value: _vm.supplyData.supplierScope,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.supplyData,
                                        "supplierScope",
                                        $$v
                                      )
                                    },
                                    expression: "supplyData.supplierScope",
                                  },
                                },
                                _vm._l(
                                  _vm.supplierScopeOptions,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4.8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "contact", label: "联系人" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: { placeholder: "请输入联系人" },
                                model: {
                                  value: _vm.supplyData.contact,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supplyData, "contact", $$v)
                                  },
                                  expression: "supplyData.contact",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4.8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "phone", label: "联系电话" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: { placeholder: "请输入联系电话" },
                                model: {
                                  value: _vm.supplyData.phone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supplyData, "phone", $$v)
                                  },
                                  expression: "supplyData.phone",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4.8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "email", label: "邮箱" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: { placeholder: "请输入邮箱" },
                                model: {
                                  value: _vm.supplyData.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supplyData, "email", $$v)
                                  },
                                  expression: "supplyData.email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4.8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "addressArr", label: "地址" } },
                            [
                              _c("el-cascader", {
                                staticStyle: { width: "200px" },
                                attrs: { options: _vm.addressDropOption },
                                model: {
                                  value: _vm.supplyData.addressArr,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supplyData, "addressArr", $$v)
                                  },
                                  expression: "supplyData.addressArr",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4.8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "address", label: "详细地址" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "860px" },
                                attrs: { placeholder: "请输入详细地址" },
                                model: {
                                  value: _vm.supplyData.address,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supplyData, "address", $$v)
                                  },
                                  expression: "supplyData.address",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "DO名称" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入DO名称" },
                                model: {
                                  value: _vm.supplyData.doName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supplyData, "doName", $$v)
                                  },
                                  expression: "supplyData.doName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "DO联系人" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入DO联系人" },
                                model: {
                                  value: _vm.supplyData.doContact,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supplyData, "doContact", $$v)
                                  },
                                  expression: "supplyData.doContact",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "DO电话" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入DO电话" },
                                model: {
                                  value: _vm.supplyData.doPhone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supplyData, "doPhone", $$v)
                                  },
                                  expression: "supplyData.doPhone",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "DO地址" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入DO地址" },
                                model: {
                                  value: _vm.supplyData.doAddress,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supplyData, "doAddress", $$v)
                                  },
                                  expression: "supplyData.doAddress",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "DO详细地址" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入DO详细地址" },
                                model: {
                                  value: _vm.supplyData.doDetailedAddress,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.supplyData,
                                      "doDetailedAddress",
                                      $$v
                                    )
                                  },
                                  expression: "supplyData.doDetailedAddress",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "清关模式",
                                prop: "clearanceModes",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    multiple: "",
                                    clearable: "",
                                    placeholder: "请选择清关模式",
                                  },
                                  model: {
                                    value: _vm.supplyData.clearanceModes,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.supplyData,
                                        "clearanceModes",
                                        $$v
                                      )
                                    },
                                    expression: "supplyData.clearanceModes",
                                  },
                                },
                                _vm._l(
                                  _vm.clearanceModesOptions,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "备注" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  maxlength: "500",
                                  autosize: { minRows: 2, maxRows: 2 },
                                  placeholder: "请输入备注",
                                },
                                model: {
                                  value: _vm.supplyData.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supplyData, "remark", $$v)
                                  },
                                  expression: "supplyData.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("BaseTab", {
                staticStyle: { "z-index": "1" },
                attrs: {
                  tabItems: _vm.tabItems,
                  propWidth: 490,
                  active: _vm.active,
                },
                on: { tabChange: _vm.tabChange },
              }),
              _c("div", { staticClass: "tab-content" }, [
                _vm.active === 0
                  ? _c("div", [
                      _c("div", { staticClass: "add-item-content" }, [
                        _c("div", { staticClass: "title" }),
                        _c(
                          "div",
                          {
                            staticClass: "add-item",
                            staticStyle: { background: "#fff" },
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "upload-demo",
                                attrs: {
                                  action: `api/SystemFile/uploadFile?source=20`,
                                  headers: _vm.headers,
                                  "file-list": _vm.fileList,
                                  "show-file-list": false,
                                  "on-success": _vm.onSuccess,
                                  "on-error": _vm.onError,
                                  accept:
                                    ".png,.PNG,.psf,.PDF,.JPG,jpg,jpeg,.JPEG",
                                  "on-progress": _vm.onProgress,
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { size: "small" },
                                  },
                                  [
                                    _c("svg-icon", {
                                      attrs: {
                                        iconClass: "upload",
                                        className: "icon",
                                      },
                                    }),
                                    _vm._v(" 选择文件上传 "),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "baseTable" },
                        [
                          _c("BaseTable", {
                            attrs: {
                              isPager: false,
                              tableData: {
                                fileds: _vm.fileds,
                                columns: _vm.supplyData.fileList,
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "opt",
                                  fn: function (row) {
                                    return [
                                      _c("i", {
                                        staticClass: "el-icon-zoom-in",
                                        attrs: { title: "预览" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.review(row.scope)
                                          },
                                        },
                                      }),
                                      _c("i", {
                                        staticClass: "el-icon-delete",
                                        attrs: { title: "删除" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteRow(
                                              row.tIndex,
                                              row.scope
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2647394771
                            ),
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm.active === 1
                  ? _c("div", [
                      _c("div", { staticClass: "add-item-content" }, [
                        _c("div", { staticClass: "title" }),
                        _c(
                          "div",
                          {
                            staticClass: "add-item",
                            staticStyle: {
                              display: "flex",
                              background: "#fff",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn",
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    _vm.dialogVisible3 = true
                                  },
                                },
                              },
                              [
                                _c("svg-icon", {
                                  attrs: {
                                    iconClass: "upload",
                                    className: "icon",
                                  },
                                }),
                                _vm._v(" 上传预报模板 "),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "baseTable" },
                        [
                          _c("BaseTable", {
                            attrs: {
                              isPager: false,
                              tableData: {
                                fileds: _vm.fileds,
                                columns: _vm.tplList,
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "opt",
                                  fn: function (row) {
                                    return [
                                      _c("el-switch", {
                                        attrs: {
                                          "active-text": row.scope.isActived
                                            ? "启用"
                                            : "停用",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onChange(
                                              row.tIndex,
                                              row.scope,
                                              _vm.active
                                            )
                                          },
                                        },
                                        model: {
                                          value: row.scope.isActived,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              row.scope,
                                              "isActived",
                                              $$v
                                            )
                                          },
                                          expression: "row.scope.isActived",
                                        },
                                      }),
                                      _c("i", {
                                        staticClass: "el-icon-zoom-in",
                                        attrs: { title: "预览" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.review(row.scope)
                                          },
                                        },
                                      }),
                                      _c("i", {
                                        staticClass: "el-icon-download",
                                        attrs: { title: "下载" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.downloadTpl(row.scope)
                                          },
                                        },
                                      }),
                                      _c("i", {
                                        staticClass: "el-icon-delete",
                                        attrs: { title: "删除" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteRow(
                                              row.tIndex,
                                              row.scope
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3875261103
                            ),
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm.active === 2
                  ? _c("div", [
                      _c("div", { staticClass: "add-item-content" }, [
                        _c("div", { staticClass: "title" }),
                        _c(
                          "div",
                          { staticClass: "add-item", on: { click: _vm.add } },
                          [
                            _c("i", {
                              staticClass: "el-icon-circle-plus-outline",
                            }),
                            _vm._v(" 添加银行账号 "),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "baseTable" },
                        [
                          _c("BaseTable", {
                            attrs: {
                              isPager: false,
                              tableData: {
                                ..._vm.tableData1,
                                columns: _vm.bankAccountList,
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "opt",
                                  fn: function (row) {
                                    return [
                                      _c("el-switch", {
                                        attrs: {
                                          "active-text": row.scope.isActived
                                            ? "启用"
                                            : "停用",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onChange(
                                              row.tIndex,
                                              row.scope,
                                              _vm.active
                                            )
                                          },
                                        },
                                        model: {
                                          value: row.scope.isActived,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              row.scope,
                                              "isActived",
                                              $$v
                                            )
                                          },
                                          expression: "row.scope.isActived",
                                        },
                                      }),
                                      _c("i", {
                                        staticClass: "el-icon-delete",
                                        attrs: { title: "删除" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeBankAccountList(
                                              row.tIndex,
                                              row.scope
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3218305034
                            ),
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c("add-bank-dialog", {
                attrs: { dialogVisible: _vm.dialogVisible2 },
                on: { ok: _vm.ok2, cancel: _vm.cancel2 },
              }),
            ],
            1
          ),
          _c("SelectTypeUploadDialog", {
            attrs: {
              dialogVisible: _vm.dialogVisible3,
              clearanceModesOptions: _vm.clearanceModesOptions,
              supplierId: _vm.editData.id,
            },
            on: {
              cancel: function ($event) {
                _vm.dialogVisible3 = false
              },
              ok: function ($event) {
                _vm.dialogVisible3 = false
                _vm.getTplList()
              },
            },
          }),
          _c("div", { staticClass: "foooter flex_c_c" }, [
            _c(
              "div",
              { staticClass: "cancel flex_c_c", on: { click: _vm.close } },
              [_vm._v("取消")]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "debounce-click",
                    rawName: "v-debounce-click",
                    value: { value: _vm.ok, args: ["form"] },
                    expression: "{ value: ok, args: ['form'] }",
                  },
                ],
                staticClass: "ok flex_c_c",
              },
              [_vm._v(" 确认 ")]
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }